var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLifeStage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14270",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11712",
    d: "M8.914 7.586a2 2 0 11-2.828 0 2 2 0 012.828 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11713",
    d: "M17.768 6.732a2.5 2.5 0 11-3.536 0 2.5 2.5 0 013.536 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11714",
    d: "M20.5 18v-1a3 3 0 00-3-3h-3a3 3 0 00-3 3v1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11715",
    d: "M8.5 14h-2a3 3 0 00-3 3v1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11716",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgLifeStage;


//////////////////
// WEBPACK FOOTER
// ./src/icons/lifeStage.svg
// module id = 895
// module chunks = 101